export default {"src":"/_next/static/media/visa.97a7730a.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};